import { useQuery } from '@tanstack/react-query';

import { organizationAdminsApi } from '../../api/lib/organization-admins';
import { userInfoKeys } from '../../api/query-keys/user-info';
import { OrganizationAdmin } from '../../api/types/organization-admin';

import { ApiError } from '@/types/interfaces/api-error';

export const useUserInfo = (enabled: boolean = true) => {
  return useQuery<OrganizationAdmin, ApiError>({
    queryKey: userInfoKeys.detail(),
    queryFn: organizationAdminsApi.fetchUserInfo,
    enabled,
  });
};
